// extracted by mini-css-extract-plugin
export default {"mg-divider":"Divider_mg-divider__14BWj","divider-text-mg":"Divider_divider-text-mg__ebJSK"};